import L from 'leaflet'
import { throttle } from 'lodash-unified'
import type { MyMap } from '@map-sdk/sdk'

class ShowWeatherTipMessage {
  private _map: any
  lyGroup: L.LayerGroup = L.layerGroup()
  clickLatLng!: L.LatLng
  type!: string
  infoDom!: HTMLElement
  constructor(map: MyMap, type: string) {
    const msgType = [
      'showSeaBreeze',
      'showWind',
      'showSeaBreezeArrow',
      'showHaiLang',
      'showHL',
      'showYangliu',
      'showAirTemperature',
      'showWaterTemperature',
      'showAtmosphericPressure',
      'showRainfall',
      'showVisibility',
    ]
    if (!msgType.includes(type)) {
      console.log('未找到对应图层的注册事件')
      return
    }
    this._map = map
    this.type = type
    this.registerEvent()
  }
  showWeatherLayer(latlng: L.LatLngExpression) {
    this.offRegisterEvent(false)
    //添加一个120px
    const point = this._map.latLngToLayerPoint(latlng)
    const start = L.point(point.x, point.y - 7)
    const end = L.point(point.x, point.y - 120)
    const startLatLng = this._map.layerPointToLatLng(start)
    const endLatLng = this._map.layerPointToLatLng(end)
    const polyline = L.polyline([startLatLng, endLatLng], {
      color: '#1d374c',
      weight: 2,
    })
    const marker = L.circleMarker(latlng, {
      radius: 6,
      color: '#fff',
      weight: 2,
      fillOpacity: 1,
    }).addTo(this._map)
    // TODO: 获取点的气象数据 此处目前模拟 接口请求
    const d = {
      winddir: 12,
      windspeed: 12,
      oceandir: 1,
      oceanspeed: 1,
      waveheight: 1,
      temperature: 1,
      pressure: 1,
    }
    // <i class="layui-icon layui-icon-close-fill weather-shuiwen-close"></i>
    let html = `<div class="weather-shuiwen-container">`
    const commHtml = `<div class="other">
                        <div class="field">流：<label style="display: inline-block;width:45px;">${
                          d.oceandir || '--'
                        }°</label>${d.oceanspeed || '--'}米/秒</div>
                        <div class="field">浪：<label style="display: inline-block;width:45px;">${
                          d.waveheight || '--'
                        }米</label>温：${d.temperature || '--'}℃</div>
                        <div class="field">压：${d.pressure || '--'}(hPa)</div>
                      </div>`
    switch (this.type) {
      // 海风、风场
      case 'showSeaBreeze':
      case 'showWind':
      case 'showSeaBreezeArrow':
        html += `<div class="field short">风：<label style="display: inline-block;width:45px;">${
          d.winddir || '--'
        }°</label>${
          this.changeWind(d.windspeed) || '--'
        }<i class="layui-icon layui-icon-down"></i></div>${commHtml}`
        break
      // 海浪
      case 'showHaiLang':
        html += `<div class="field short">浪：${
          d.waveheight || '--'
        }米<i class="layui-icon layui-icon-down"></i></div>${commHtml}`
        break
      // 海流、洋流
      case 'showHL':
      case 'showYangliu':
        html += `<div class="field short">流：<label style="display: inline-block;width:45px;">${
          d.oceandir || '--'
        }°</label>${
          d.oceanspeed || '--'
        }米/秒<i class="layui-icon layui-icon-down"></i></div>${commHtml}`
        break
      // 气温、水温
      case 'showAirTemperature':
      case 'showWaterTemperature':
        html += `<div class="field short">温：${
          d.temperature || '--'
        }℃ <i class="layui-icon layui-icon-down"></i></div>${commHtml}`

        break
      // 气压
      case 'showAtmosphericPressure':
        html += `<div class="field short">压：${
          d.pressure || '--'
        }(hPa) <i class="layui-icon layui-icon-down"></i></div>${commHtml}`
        break
      // 降雨量
      case 'showRainfall':
        html += `<div class="field short">降雨量：${
          d.pressure || '--'
        }(hPa) <i class="layui-icon layui-icon-down"></i></div>${commHtml}`
        break
      // 能见度
      case 'showVisibility':
        html += `<div class="field short">能见度：${
          d.pressure || '--'
        }(hPa) <i class="layui-icon layui-icon-down"></i></div>${commHtml}`
        break
    }

    html += `</div>` // <i class="layui-icon layui-icon-up"></i>

    marker.bindTooltip(html, {
      direction: 'right',
      offset: [-7, -10],
      opacity: 1,
      className: 'weather-shuiwen-tooltip',
      permanent: true,
      interactive: true,
    })

    this.lyGroup.addLayer(polyline)
    this.lyGroup.addLayer(marker)
    this.lyGroup.addTo(this._map)
    marker.addTo(this._map)
  }

  private _Event = {
    zoomEnd: () => {
      this.clickLatLng && this.showWeatherLayer(this.clickLatLng)
    },
    click: (e: { latlng: L.LatLng }) => {
      this.clickLatLng = e.latlng
      this.showWeatherLayer(e.latlng)
    },
    mouseMove: throttle(
      (e: { latlng: L.LatLng }) => this._renderHtml(e.latlng),
      1000
    ),
  }

  private _renderHtml = (latlng: L.LatLng) => {
    const { lat, lng } = latlng
    const data = {
      WindSpeed: lat,
      WindDir: lng,
      WaveHeght: 1,
      OceanSpeed: 1,
      OceanDir: 1,
      WaveDir: 1,
      Temprature: 1,
      Pressure: 1,
    }

    if (!this.infoDom) {
      this.infoDom = L.DomUtil.create(
        'div',
        'weather-info-mousemove',
        this._map._container
      )
      L.DomEvent.disableClickPropagation(this.infoDom)
      L.DomEvent.disableScrollPropagation(this.infoDom)
      new L.Draggable(this.infoDom).enable()
    }
    const html = `<div class="weather-title">气象信息</div><div class="seamete_info_box">
                      <ul >
                        <li>风速：<label id="WindSpeed">${
                          data.WindSpeed || '--'
                        }</label></li>
                        <li>风向：<label id="WindDir">${
                          data.WindDir || '--'
                        }</label>度</li>
                        <li>浪高：<label id="WaveHeght">${
                          data.WaveHeght || '--'
                        }</label>米</li>
                        <li>流速：<label id="OceanSpeed">${
                          data.OceanSpeed || '--'
                        }</label>米/秒</li>
                        <li>流向：<label id="OceanDir">${
                          data.OceanDir || '--'
                        }</label>度</li>
                        <li>浪向：<label id="WaveDir">${
                          data.WaveDir || '--'
                        }</label>度</li>
                        <li>温度：<label id="Temprature">${
                          data.Temprature || '--'
                        }</label>摄氏度</li>
                        <li>气压：<label id="Pressure">${
                          data.Pressure || '--'
                        }</label>hPa</li>
                      </ul>
                    </div>`
    this.infoDom.innerHTML = html
  }

  registerEvent() {
    this.offRegisterEvent()
    this._map.on('zoomend', this._Event.zoomEnd)

    //地图点击事件
    this._map.on('click', this._Event.click)

    this._map.on('mousemove', this._Event.mouseMove)
    this._renderHtml(this._map.getCenter())
  }
  offRegisterEvent(isClearEvent = true) {
    this.lyGroup && this.lyGroup.clearLayers()
    if (isClearEvent && this._map) {
      this._map.off('zoomend', this._Event.zoomEnd)
      this._map.off('click', this._Event.click)
      this._map.off('mousemove', this._Event.mouseMove)
      this.infoDom && L.DomUtil.remove(this.infoDom)
    }
  }

  /**
   * 气象信息 角度
   * @param wind
   * @returns
   */
  winddir(wind: string | number) {
    wind = Number.parseFloat(`${wind}`)
    if (wind > 0 && wind <= 22.5) {
      return 'NNE'
    } else if (wind > 22.5 && wind <= 45) {
      return 'NE'
    } else if (wind > 45 && wind <= 67.5) {
      return 'ENE'
    } else if (wind > 67.5 && wind <= 90) {
      return 'E'
    } else if (wind > 90 && wind <= 112.5) {
      return 'ESE'
    } else if (wind > 112.5 && wind <= 135) {
      return 'SE'
    } else if (wind > 135 && wind <= 157.5) {
      return 'SSE'
    } else if (wind > 157.5 && wind <= 180) {
      return 'S'
    } else if (wind > 180 && wind <= 202.5) {
      return 'SSW'
    } else if (wind > 202.5 && wind <= 225) {
      return 'SW'
    } else if (wind > 225 && wind <= 247.5) {
      return 'WSW'
    } else if (wind > 247.5 && wind <= 270) {
      return 'W'
    } else if (wind > 270 && wind <= 292.5) {
      return 'WNW'
    } else if (wind > 292.5 && wind <= 315) {
      return 'NW'
    } else if (wind > 315 && wind <= 337.5) {
      return 'NNW'
    } else if (wind > 337.5 && wind <= 360) {
      return 'N'
    } else {
      return '-'
    }
  }
  /**
   * 气象风级
   * @param wind
   * @returns
   */
  private changeWind(wind: number) {
    let i
    wind = wind ? Number(Number.parseFloat(`${wind}`).toFixed(1)) : 0
    if (wind > 0 && wind <= 1.5) {
      i = 1
    } else if (wind >= 1.6 && wind <= 3.3) {
      i = 2
    } else if (wind >= 3.4 && wind <= 5.4) {
      i = 3
    } else if (wind >= 5.5 && wind <= 7.9) {
      i = 4
    } else if (wind >= 8 && wind <= 10.7) {
      i = 5
    } else if (wind >= 10.8 && wind <= 13.8) {
      i = 6
    } else if (wind >= 13.9 && wind <= 17.1) {
      i = 7
    } else if (wind >= 17.2 && wind <= 20.7) {
      i = 8
    } else if (wind >= 20.8 && wind <= 24.4) {
      i = 9
    } else if (wind >= 24.5 && wind <= 28.4) {
      i = 10
    } else if (wind >= 28.5 && wind <= 32.6) {
      i = 11
    } else if (wind > 32.6) {
      i = 12
    }
    return wind === 0 ? '--' : `${wind}米/秒 (${i || '--'}级风)`
  }
}

const showWeatherTipMessage = (map: MyMap, type: string) =>
  new ShowWeatherTipMessage(map, type)

export { showWeatherTipMessage }
